import RepSignalWordmark from "@/assets/RepSignalWordmark.png";
import MarketSignalLogo from "@/assets/MarketSignalLogo.svg";

// Identifiers must match VALID_PRODUCTS in app/utils/user.py
export const PRODUCTS = Object.freeze({
  REPSIGNAL: "repsignal",
  MARKETSIGNAL: "marketsignal",
});

export const PRODUCT_META = Object.freeze({
  [PRODUCTS.REPSIGNAL]: {
    key: PRODUCTS.REPSIGNAL,
    name: "RepSignal",
    tagline: "Field sales enablement tool",
    // Standalone-disabled RepSignal customers may still use it in Salesforce
    disabledNote:
      "Not enabled for your organization. If your team uses RepSignal, it’s available in Salesforce.",
    logo: RepSignalWordmark,
    // Both wordmarks share the same logomark and text-to-height ratio, so an
    // equal rendered height gives equal letter and icon sizes.
    menuLogoHeight: "23.4px",
    homeRoute: "home",
  },
  [PRODUCTS.MARKETSIGNAL]: {
    key: PRODUCTS.MARKETSIGNAL,
    name: "MarketSignal",
    tagline: "Marketing and analytics tool",
    disabledNote: "Not enabled for your organization",
    logo: MarketSignalLogo,
    menuLogoHeight: "23.4px",
    homeRoute: "marketSignalHome",
  },
});

export const PRODUCT_LIST = Object.values(PRODUCT_META);
